import { TimePicker } from "@tql/ui-components-react/kendo/dateinputs";
import { format } from "date-fns";
import { useEffect, useState } from "react";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { GlobalCarrier } from "~/shared/schemas/auto-dispatch-schema.ts";

import { DispatchTimeFilterCell } from "../../components/grid/columns/dispatch-time-filter-cell/index.tsx";
import { HeaderCell } from "../../components/grid/columns/header-cell/index.tsx";
import { getTimeFromTimeString } from "../../utils/time-from-date.ts";
import type { column } from "./types.ts";
import type { CellWrapper } from "./with-loader.tsx";

const handleClick = (e: React.MouseEvent) => {
	e.stopPropagation();
};

export const dispatchTimeColumn = (
	cellWrapper: CellWrapper,
	updateCarrier: ((carrier: GlobalCarrier) => void) | undefined,
): column => ({
	field: "dispatchTime",
	title: "Dispatch Time",
	group: ["global"],
	// `dispatchTime` is persisted as an "HH:mm" string, so Kendo's built-in
	// text filter is the right match (contains/starts-with on the raw value).
	filter: "text",
	filterable: true,
	filterCell: DispatchTimeFilterCell,
	sortable: true,
	headerCell: (props) => (
		<HeaderCell
			title={props.title ?? ""}
			tooltipText={
				"Shipments tendered prior to the day of pick up should be auto dispatched at 9PM the night before pick up. If the shipment is tendered day of pick up or post 9PM the day prior to pick up, it can be automatically dispatched at the time of tender to TQL."
			}
		/>
	),
	cells: {
		data: cellWrapper((props) => {
			const carrier = props.dataItem as GlobalCarrier;
			const [localTime, setLocalTime] = useState<Date | null>(
				getTimeFromTimeString(carrier?.dispatchTime ?? undefined),
			);

			useEffect(() => {
				setLocalTime(getTimeFromTimeString(carrier?.dispatchTime ?? undefined));
			}, [carrier?.dispatchTime]);

			const commitTime = () => {
				updateCarrier?.({
					...carrier,
					dispatchTime: localTime ? format(localTime, "HH:mm") : null,
				});
			};

			return (
				<GridTd onClick={handleClick} tdProps={props.tdProps}>
					<TimePicker
						onBlur={commitTime}
						onChange={(e) => {
							setLocalTime(e.value);
						}}
						onClose={commitTime}
						value={localTime}
					/>
				</GridTd>
			);
		}),
	},
});
